import { useEffect,useState } from "react";
import * as Constants from '../constants';
import Loading from "../components/Loading";
import post from "../post";
import {useLocation as location2} from 'wouter';

const Contact= () => {
    const [contactData,setContactData]=useState(false);
    const [location, navigate] = location2();
    useEffect(()=>{
        const fetchData=async ()=>{
            //const d=await getContactData();
            const x=await post('getContactData',{},false);
            if(x.result){
                setContactData(x.data);
                console.log(x.data);
            }else{
                navigate('/');
            }
        }
        fetchData();
    },[]);
    return (
        <div className="min-h-screen bg-neutral-50 relative pb-24 text-neutral-700">
            <Loading isOpen={!contactData} />
                <div className="py-8 px-4 md:px-8 lg:px-16 mt-4">
                    <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
                            <h3 className="text-lg font-semibold mb-4 text-primary-600 flex items-center">
                                <span className="material-symbols-outlined mr-2">storefront</span>
                                Sucursales
                            </h3>
                            <div className="space-y-4">
                                {contactData && contactData.sucursales && contactData.sucursales.map((s,index)=>(
                                    <div key={'sucursal'+index} className="p-3 border border-neutral-200 rounded-lg hover:bg-neutral-50 transition-colors text-black">
                                        <p className="font-medium">{s.nombre}</p>
                                        <p className="text-sm text-neutral-600">{s.direccion}</p>
                                        <p className="text-sm text-neutral-600">Horario: {s.horario}</p>
                                    </div>
                                ))}
                                
                               
                            </div>
                        </div>
                    

                    <div className=" mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
                        <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
                            <h3 className="text-lg font-semibold mb-4 text-primary-600 flex items-center">
                                <span className="material-symbols-outlined mr-2">storefront</span>
                                Contacto
                            </h3>
                            {contactData && contactData.config && contactData.config.tels.quejas && (
                                <a
                                    href={"https://wa.me/" + contactData.config.tels.quejas}
                                    className="flex items-center p-3 bg-green-50 rounded-lg text-green-800 hover:bg-green-100 transition-colors mb-3"
                                    target="_blank"
                                >
                                    <i className="fa-brands fa-whatsapp text-2xl mr-3 text-green-600"></i>
                                    
                                    <div>
                                        <p className="font-medium">Quejas y sugerencias</p>
                                        <p className="text-sm text-neutral-600">{contactData.config.horarios.quejas}</p>
                                    </div>
                                </a>
                            )}
                            {contactData && contactData.config && contactData.config.tels.rh && (
                                <a
                                    href={"https://wa.me/" + contactData.config.tels.rh}
                                    className="flex items-center p-3 bg-green-50 rounded-lg text-green-800 hover:bg-blue-100 transition-colors mb-3"
                                    target="_blank"
                                >
                                    <i className="fa-brands fa-whatsapp text-2xl mr-3 text-green-600"></i>
                                    
                                    <div>
                                        <p className="font-medium">Recursos Humanos</p>
                                        <p className="text-sm text-neutral-600">{contactData.config.horarios.rh}</p>
                                    </div>
                                </a>
                            )}
                            {contactData && contactData.config && contactData.config.tels.proveedores && (
                                <a
                                    href={"https://wa.me/" + contactData.config.tels.proveedores}
                                    className="flex items-center p-3 bg-green-50 rounded-lg text-green-800 hover:bg-green-100 transition-colors mb-3"
                                    target="_blank"
                                >
                                    <i className="fa-brands fa-whatsapp text-2xl mr-3 text-green-600"></i>
                                    
                                    <div>
                                        <p className="font-medium">Proveedores</p>
                                        <p className="text-sm text-neutral-600">{contactData.config.horarios.proveedores}</p>
                                    </div>
                                </a>
                            )}
                        </div>

                        

                        <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
                            <h3 className="text-lg font-semibold mb-4 text-primary-600 flex items-center">
                                <span className="material-symbols-outlined mr-2">description</span>
                                Legales
                            </h3>
                            <a
                                href={Constants.BASE_URL+"clienteappserver/legal/tandc"}
                                className="flex items-center p-3 border border-neutral-200 rounded-lg hover:bg-neutral-50 transition-colors mb-4"
                                target="_blank"
                            >
                                <span className="material-symbols-outlined mr-3 text-neutral-700">gavel</span>
                                <p className="font-medium">Términos y Condiciones</p>
                            </a>
                            <a
                                href={Constants.BASE_URL+"clienteappserver/legal/privacy"}
                                className="flex items-center p-3 border border-neutral-200 rounded-lg hover:bg-neutral-50 transition-colors mb-4"
                                target="_blank"
                            >
                                <span className="material-symbols-outlined mr-3 text-neutral-700">security</span>
                                <p className="font-medium">Política de Privacidad</p>
                            </a>
                            
                            
                            {/*<button className="w-full mt-4 p-3 bg-red-50 text-red-700 border border-red-200 rounded-lg hover:bg-red-100 transition-colors flex items-center justify-center">
                                <span className="material-symbols-outlined mr-2">delete</span>
                                <span className="font-medium">Borrar mi información</span>
                            </button>*/}
                        </div>
                    </div>

                    {/*<div className="bg-white p-6 rounded-lg shadow-md">
                        <h3 className="text-lg font-semibold mb-4 text-primary-600">Send Us a Message</h3>
                        <form className="space-y-4">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-neutral-700 mb-1">Name</label>
                                    <input
                                        type="text"
                                        className="w-full p-2 border border-neutral-300 rounded-md focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-neutral-700 mb-1">Email</label>
                                    <input
                                        type="email"
                                        className="w-full p-2 border border-neutral-300 rounded-md focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all"
                                    />
                                </div>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-neutral-700 mb-1">Subject</label>
                                <input
                                    type="text"
                                    className="w-full p-2 border border-neutral-300 rounded-md focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-neutral-700 mb-1">Message</label>
                                <textarea
                                    rows="4"
                                    className="w-full p-2 border border-neutral-300 rounded-md focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all"
                                ></textarea>
                            </div>
                            <button
                                type="submit"
                                className="px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700 transition-colors"
                            >
                                Send Message
                            </button>
                        </form>
                    </div>*/}
                </div>
            </div>
                
           );              
 }

 export default Contact;     